import { useState, useEffect } from "react";
import InputWithLabel from "./InputWithLabel";
import Button from "../buttons/button";
import useTranslator from "../../../hooks/useTranslator";

const initialFormData = {
  entered_date: "",
};

const SortingFilter = ({ onApplyFilter, onClose, filters = {} }) => {
  const [filtersData, setFiltersData] = useState({
    entered_date: filters.entered_date || "",
  });

  const { _t } = useTranslator();

  useEffect(() => {
    setFiltersData({
      entered_date: filters.entered_date || "",
    });
  }, [filters.entered_date]);

  const handleChange = (e) => {
    setFiltersData({ ...filtersData, [e.target.name]: e.target.value });
  };

  const handleReset = (e) => {
    e.preventDefault();
    setFiltersData(initialFormData);
    onApplyFilter(initialFormData);
    if (onClose) onClose();
  };

  const handleApply = (e) => {
    e.preventDefault();
    onApplyFilter({ ...filtersData });
    if (onClose) onClose();
  };

  return (
    <div className="dropdown_body">
      <h5 className="mb-3 border-bottom">{_t("filter_heading", "Filter")}</h5>

      <InputWithLabel
        label={_t("entered_date", "Entered Date")}
        type="date"
        name="entered_date"
        value={filtersData.entered_date}
        onChange={handleChange}
      />

      {/* <InputWithLabel
        label={_t("pallet_code", "Pallet Code")}
        type="text"
        name="pallet_code"
        value={filtersData.pallet_code}
        onChange={handleChange}
      /> */}



      <div className="d-flex justify-content-between mt-3">
        <Button
          onClick={handleReset}
          label={_t("reset_button", "Reset")}
          className="reset_btn"
        />
        <Button
          className="cmn_btn"
          label={_t("apply_button", "Apply")}
          onClick={handleApply}
        />
      </div>
    </div>
  );
};

export default SortingFilter;
